export const localizedRoutes = {
    about: {
        en: 'about',
        nl: 'over-ons',
    },
    campaigns: {
        en: 'cases',
        nl: 'cases',
    },
    pr: {
        en: 'pr',
        nl: 'pr',
    },
    contact: {
        en: 'contact',
        nl: 'contact',
    },
    cases: {
        en: 'cases',
        nl: 'cases',
    },
    privacy: {
        en: 'privacy',
        nl: 'privacy',
    },
    terms: {
        en: 'terms',
        nl: 'algemene-voorwaarden',
    },
    article: {
        en: 'article',
        nl: 'reads',
    },
    vacancies: {
        en: 'vacancies',
        nl: 'vacatures',
    },
    bcorp: {
        en: 'b-corp',
        nl: 'b-corp',
    },
    openVac: {
        en: 'open-sollicitatie',
        nl: 'open-sollicitatie',
    },
};
